import request from './request';

const templates = [
  'https://tagmango.com/staticassets/plutus_theme_v4.json',
  'https://tagmango.com/staticassets/athena_theme_2.json',
  'https://tagmango.com/staticassets/ilh_theme_v3.json',
  'https://tagmango.com/staticassets/course_template_v4.json',
  'https://tagmango.com/staticassets/bluetheme.json', //thechartisttheme
  'https://tagmango.com/staticassets/greentheme.json', // acadmoneytheme
  'https://tagmango.com/staticassets/skytheme.json', //skillyticaltheme
  'https://tagmango.com/staticassets/navybluetheme.json', //financewithsharan
  'https://tagmango.com/staticassets/yellowtheme.json', //shailajatheme
  'https://tagmango.com/staticassets/purpletheme.json', //rajtheme
  'https://tagmango.com/staticassets/tealtheme.json', //rachnatheme
  'https://tagmango.com/staticassets/mindfluentialtrading.json', //mindfluentialtrading
  'https://tagmango.com/staticassets/jatanskillnation.json', //jatanskillnation
  'https://tagmango.com/staticassets/anusha_rathod_course.json', //anusha_rathod_course
  'https://tagmango.com/staticassets/heena_sheikh_theme.json', //heena_sheikh_theme
  'https://tagmango.com/staticassets/jdfhbfhbfhjdeditorState.json', //be10x
  'https://tagmango.com/staticassets/1704477930298editorState.json', //ruchirgupta
  'https://tagmango.com/staticassets/1704788460727editorState.json', //spoorthivishwas
  'https://tagmango.com/staticassets/1700482748708editorState.json', //testpage1
  'https://tagmango.com/staticassets/1703830986902editorState.json', //test-page-state
];

export async function fetchTemplate(id) {
  const res = await request({
    url: templates[id],
    method: 'GET',
  });
  console.log(res);
  return res;
}
